import React from "react";
import './GlobalCard.scss'

const GlobalCard = ({children,className})=>
{
    return(
        <div className={`GlobalCard ${className}`} >
            {children}
        </div>
    )
}
export default GlobalCard